import React, { FC, SVGProps } from 'react'

import { CartFulfillmentKinds } from 'Types'

import ICONS from './components/Icons'

type FulfillmentIconProps = SVGProps<SVGSVGElement> & {
  kind: string
}

const FulfillmentIcon: FC<FulfillmentIconProps> = ({ kind, ...rest }) => {
  const Icon = ICONS[kind] || ICONS[CartFulfillmentKinds.PICKUP]
  return <Icon {...rest} />
}

export default FulfillmentIcon
